import { addErrorDataAttribute } from 'app/components/ui/ErrorFormScrollHandler'
import { FormFeedback } from 'app/components/ui/FormFeedback'
import { Input, InputProps } from 'app/components/ui/Input'
import { Label } from 'app/components/ui/Label'
import React from 'react'
import { get, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

type Props = {
  name: string
  label?: string
  labelColor?: string
  errorLabelColor?: string
  labelRequired?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
} & Omit<InputProps, 'value' | 'onChange'>
export const SmartInput = ({
  name,
  id,
  label,
  labelColor,
  errorLabelColor,
  labelRequired,
  className,
  onChange,
  ...rest
}: Props): JSX.Element => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  const error = get(errors, name)

  const { onChange: onChangeRegister, ...registerProps } = register(name)

  return (
    <div className={className}>
      {label && (
        <Label htmlFor={id ?? name} color={labelColor} disabled={rest.disabled}>
          {label} {labelRequired ? <RequiredSpan> * </RequiredSpan> : null}
        </Label>
      )}
      <Input
        id={id ?? name}
        onChange={(e) => {
          // Calls react hook form onChange, needed for form to work
          onChangeRegister(e)

          // Calls custom onChange if present
          if (onChange) onChange(e)
        }}
        {...registerProps}
        {...rest}
        invalid={!!error}
        {...addErrorDataAttribute(!!error)}
      />
      {error ? (
        <FormFeedback customColor={errorLabelColor} variant='error'>
          {error.message}
        </FormFeedback>
      ) : null}
    </div>
  )
}

const RequiredSpan = styled.span`
  color: ${({ theme }) => theme.color.secondari.arancioneScuro};
`
